var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3, _react_refresh_temp_4, _react_refresh_temp_5;
var _react_refresh_temp_6;
_react_refresh_temp_6 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Box, Button, Compass03Icon, LifeBuoy02Icon, LightBulb03Icon, Menu, MenuItem, MessageTextSquare02Icon, Trans, translate, } from '@lucidlink/uicore';
import { SHARE_FEEDBACK_URL, SUBMIT_REQUEST_URL, WEBSITE_GETTING_STARTED_LINK, WEBSITE_SUPPORT_LINK, } from '#constants';
import { DEPENDENCY_KEYS, useAuthProvider, useDependency } from '#context';
import { useGenerateZendeskVerificationCode } from '#hooks';
import styles from './support-menu.module.css';
export const SupportMenuTrigger = (triggerProps) => {
    const { isFloatingBoxActive, ...props } = triggerProps;
    return (_jsx(Button, { ...props, "data-testid": "support-menu-trigger", kind: "ghost", StartIcon: MessageTextSquare02Icon, children: _jsx(Trans, { children: "Feedback and support" }) }));
};
_react_refresh_temp_1 = SupportMenuTrigger;
$RefreshReg$(_react_refresh_temp_1, "SupportMenuTrigger");
export const SubmitSupportRequestMenuItem = () => {
    _react_refresh_temp_6();
    const { currentUser } = useAuthProvider();
    const webClientUrl = useDependency(DEPENDENCY_KEYS.CLIENT_BASE_URL);
    const onError = useCallback(() => {
        window.open(WEBSITE_SUPPORT_LINK, '_blank')?.focus();
    }, []);
    const { createVerificationCode } = useGenerateZendeskVerificationCode({
        onError,
    });
    const handleClick = async () => {
        const email = currentUser?.email;
        if (!email) {
            onError();
            return;
        }
        const { code, userId } = await createVerificationCode();
        const url = new URL('/zendesk-auth', webClientUrl);
        url.search = new URLSearchParams({
            userId,
            code,
            return_to: SUBMIT_REQUEST_URL,
        }).toString();
        window.open(url, '_blank')?.focus();
    };
    return (_jsx(MenuItem, { "data-testid": "submit-support-request", LeadingIcon: LifeBuoy02Icon, onClick: () => {
            void handleClick();
        }, text: translate('Submit support request'), to: "#" }));
};
_react_refresh_temp_2 = SubmitSupportRequestMenuItem;
$RefreshReg$(_react_refresh_temp_2, "SubmitSupportRequestMenuItem");
_react_refresh_temp_6(SubmitSupportRequestMenuItem, "7ox9xhZpnlyuBaug4tp58duJ2XU=", false, () => [useAuthProvider, useDependency, useGenerateZendeskVerificationCode]);
export const HelpCenterMenuItem = () => (_jsx(MenuItem, { "data-testid": "help-center", LeadingIcon: Compass03Icon, target: "_blank", text: translate('Help center'), to: WEBSITE_GETTING_STARTED_LINK }));
_react_refresh_temp_3 = HelpCenterMenuItem;
$RefreshReg$(_react_refresh_temp_3, "HelpCenterMenuItem");
export const SubmitFeedbackMenuItem = () => (_jsx(MenuItem, { "data-testid": "share-feedback", LeadingIcon: LightBulb03Icon, target: "_blank", text: translate('Submit feedback'), to: SHARE_FEEDBACK_URL }));
_react_refresh_temp_4 = SubmitFeedbackMenuItem;
$RefreshReg$(_react_refresh_temp_4, "SubmitFeedbackMenuItem");
export const SupportMenuContentContainer = ({ children, }) => (_jsx(Box, { className: styles.Container, gap: "s", kind: "level3", orientation: "vertical", padding: "s", radius: "m", children: _jsx(Menu, { navigationType: "arrows", children: children }) }));
_react_refresh_temp_5 = SupportMenuContentContainer;
$RefreshReg$(_react_refresh_temp_5, "SupportMenuContentContainer");
